import { render, staticRenderFns } from "./OverflowBlockquoteSection.vue?vue&type=template&id=272bbdc7&scoped=true"
import script from "./OverflowBlockquoteSection.vue?vue&type=script&lang=js"
export * from "./OverflowBlockquoteSection.vue?vue&type=script&lang=js"
import style0 from "./OverflowBlockquoteSection.vue?vue&type=style&index=0&id=272bbdc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272bbdc7",
  null
  
)

export default component.exports